import {
  File,
  FileArchive,
  FileAudio,
  FileCode,
  FileImage,
  FileSpreadsheet,
  FileText,
  FileVideo,
  NotebookPen,
  Presentation,
  type LucideIcon,
} from 'lucide-react';
import type { AssetKind } from '@ready/shared';

/** Human-readable size: 532 B, 14 KB, 3.2 MB, 1.1 GB. */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit++;
  }
  const digits = value < 10 ? 1 : 0;
  return `${value.toFixed(digits).replace(/\.0$/, '')} ${units[unit]}`;
}

const ICONS: Record<AssetKind, LucideIcon> = {
  video: FileVideo,
  audio: FileAudio,
  image: FileImage,
  pdf: FileText,
  slides: Presentation,
  document: FileText,
  spreadsheet: FileSpreadsheet,
  notebook: NotebookPen,
  code: FileCode,
  markdown: FileText,
  archive: FileArchive,
  other: File,
};

/** Icon component for an asset kind. */
export function assetIcon(kind: AssetKind): LucideIcon {
  return ICONS[kind] ?? File;
}

/** Lowercase extension without the dot ("" when there is none). */
export function fileExtension(filename: string): string {
  const dot = filename.lastIndexOf('.');
  return dot > 0 ? filename.slice(dot + 1).toLowerCase() : '';
}
